module.exports = __webpack_public_path__ + "static/media/story-x.25db1af0.jpg";